import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getFeedbacksRpcContract = rpcContract({
  name: "getFeedbacks",
  paramsSchema: v.object({
    authenticationUserId: v.optional(v.string()),
    pageUrl: v.optional(v.string()),
    limit: v.optional(v.number()),
    offset: v.optional(v.number()),
    sortOrder: v.optional(v.picklist(["asc", "desc"] as const)),
  }),
  resultSchema: v.object({
    feedbacks: v.array(
      v.object({
        id: v.string(),
        authentication_user_id: v.nullable(v.string()),
        comment: v.nullable(v.string()),
        is_positive: v.nullable(v.boolean()),
        page_url: v.nullable(v.string()),
        user_agent: v.nullable(v.string()),
        ip_address: v.nullable(v.string()),
        published_at: v.nullable(v.string()),
        user: v.optional(
          v.object({
            id: v.string(),
            email: v.string(),
            name: v.string(),
          }),
        ),
      }),
    ),
    totalCount: v.number(),
  }),
});

export type GetFeedbacksParams = v.InferOutput<(typeof getFeedbacksRpcContract)["paramsSchema"]>;
export type GetFeedbacksResult = v.InferOutput<(typeof getFeedbacksRpcContract)["resultSchema"]>;
export type Feedback = v.InferOutput<(typeof getFeedbacksRpcContract)["resultSchema"]>["feedbacks"][0];
